'use client';
import React from "react";
import logo from "../public/image/zync-logo.png";// Replace with your actual path
import Image from "next/image";

export default function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center space-y-4 animate-pulse">
        <Image src={logo} alt="Zync Logo" className="w-28 h-28" />
        <p className="text-xl font-semibold text-blue-900">Loading...</p>
      </div>
    </div>
  );
}